module.exports = __webpack_public_path__ + "img/3_cover1.92d933a6.png";